module.exports = __webpack_public_path__ + "img/app.d7f57f3c.png";